'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _helpers = require('./_helpers');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classes = {
  container: 'js-DrawerFilters',
  items: 'js-DrawerFilters_Items',
  item: 'js-DrawerFilters_Item',
  trigger: 'js-DrawerFilters_Trigger',
  drawer: 'js-DrawerFilters_Drawer',
  back: 'js-DrawerFilters_Back'
};

var listeners = (0, _create2.default)(_helpers.Listeners);
var state = new _helpers.ReactiveState({
  hasChildrenOpen: false
});
var activeAttribute = 'data-has-child-open';

function init(_ref) {
  var el = _ref.el;

  listeners.add(el, 'click', handleTriggerClick);
  listeners.add(el, 'click', handleBackClick);

  window.closeAllMobileNavDrawers = function () {
    state.hasChildrenOpen = false;

    var activeItems = (0, _functional.getElements)('.' + classes.item + '[aria-selected=\'true\']');
    activeItems.forEach(function (el) {
      return el.setAttribute('aria-selected', 'false');
    });

    var overflowedDrawers = (0, _functional.getElements)('.' + classes.drawer + '[' + activeAttribute + ']');
    overflowedDrawers.forEach(function (el) {
      return el.removeAttribute(activeAttribute);
    });
  };
}

function handleTriggerClick(_ref2) {
  var target = _ref2.target;

  var trigger = target.closest('.' + classes.trigger);
  if (!trigger) return;

  var parentItem = getParentItem(trigger);
  var parentDrawer = getParentDrawer(trigger);

  parentItem.setAttribute('aria-selected', 'true');

  if (parentDrawer) {
    parentDrawer.setAttribute(activeAttribute, '');
  }

  state.hasChildrenOpen = true;
}

function handleBackClick(_ref3) {
  var target = _ref3.target;

  var back = target.closest('.' + classes.back);
  if (!back) return;

  var parentItem = getParentItem(back);
  var parentDrawer = getParentDrawer(parentItem);

  parentItem.setAttribute('aria-selected', 'false');

  if (parentDrawer) {
    parentDrawer.removeAttribute(activeAttribute);
  }

  state.hasChildrenOpen = false;
}

function getParentItem(el) {
  return el.closest('.' + classes.item);
}

function getParentDrawer(el) {
  return el.closest('.' + classes.drawer);
}